import React, { useState } from "react";
import PropTypes from "prop-types";
import CircularProgress from "@material-ui/core/CircularProgress";
import IconButton from "@material-ui/core/IconButton";
import Tooltip from "@material-ui/core/Tooltip";
import DeleteIcon from "@material-ui/icons/Delete";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContentText from "@material-ui/core/DialogContentText";
import Dialog from "@material-ui/core/Dialog";
import Button from "@material-ui/core/Button";
import { deactivateOrganization } from "../../data/organization-store";

function DeactivateOrgButton(props) {
  const { organizationId, organizationName, onShowSnackbar } = props;

  const [confirmOpen, setConfirmOpen] = useState(false);
  const [deactivating, setDeactivating] = useState(false);

  const handleClick = () => {
    setConfirmOpen(true);
  };

  const handleConfirm = async () => {
    setConfirmOpen(false);
    setDeactivating(true);

    try {
      await deactivateOrganization(organizationId);

      onShowSnackbar({
        open: true,
        message: `${organizationName} has been deactivated.`,
        severity: "success",
        autoHideDuration: 6000,
      });
    } catch (error) {
      onShowSnackbar({
        open: true,
        message: "Failed to deactivate organization.",
        severity: "error",
        error: error,
      });
    } finally {
      setDeactivating(false);
    }
  };

  const handleCancel = () => {
    setConfirmOpen(false);
  };

  return (
    <React.Fragment>
      <Tooltip title="Deactivate" aria-label="deactivate organization">
        {deactivating ? (
          <CircularProgress size={24} />
        ) : (
          <IconButton
            aria-label="deactivate organization"
            onClick={handleClick}
          >
            <DeleteIcon />
          </IconButton>
        )}
      </Tooltip>

      <Dialog open={confirmOpen} onClose={handleCancel}>
        <DialogTitle>Deactivate this organization?</DialogTitle>
        <DialogContent>
          <DialogContentText>
            If you proceed, {organizationName} and all of its users will be
            deactivated. Users in this organization will not be able to sign in
            until the organization is reactivated.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button autoFocus onClick={handleCancel} color="primary">
            Cancel
          </Button>
          <Button onClick={handleConfirm} color="primary">
            Deactivate
          </Button>
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
}

DeactivateOrgButton.propTypes = {
  organizationId: PropTypes.string,
  organizationName: PropTypes.string,
  onShowSnackbar: PropTypes.func,
};

export default DeactivateOrgButton;
